import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type MyRequestsState = {
  count: number;
};

const initialState: MyRequestsState = { count: 0 };

export const myRequestsSlice = createSlice({
  name: 'myRequests',
  initialState,
  reducers: {
    setMyRequestsCount: (state, { payload }: PayloadAction<number>) => {
      state.count = payload;
    },
  },
});

export const { reducer: myRequestsReducer } = myRequestsSlice;
